
import Mapboard from './Mapboard';
import MapPreview from './MapPreview';


export {Mapboard,MapPreview};
export default Mapboard;